import { executeRequest, Request } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { sitConfigWithTraceId } from './config'
import { getFormattedDate } from './eosCreateWorkItem'

const getCreateSubGroupRequestBody = (data: any) => {
  return {
    applicationId: `NEW-${getFormattedDate()}`,
    ...data,
  }
}

const createSubGroupReq = (data: any, tokens: any, traceId: string) => {
  const request: Request<{}> = {
    config: sitConfigWithTraceId(tokens, traceId),
    apiPath: APIEndPoints.createSubGroup_camunda,
    body: getCreateSubGroupRequestBody(data),
    method: 'POST',
    headers: sitConfigWithTraceId(tokens, traceId).headers,
  }
  return executeRequest(request)
    .then((data) => {
      return data
    })
    .catch((err) => {
      throw err
    })
}

export { createSubGroupReq }
